import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { IdentificationProvider } from '@shared/enums/identification-provider.enum';
import { IdentificationProviderService, User } from '../../../auth/identification-provider.service';

@Component({
  selector: 'form-identification-provider',
  templateUrl: './identification-provider.component.html',
  styleUrls: ['./identification-provider.component.scss']
})
export class IdentificationProviderComponent {
  public readonly IdentificationProvider = IdentificationProvider;
  public user$: Observable<User | null>;
  @Output() beforeLogin: EventEmitter<void> = new EventEmitter<void>();
  @Input() public providersList: IdentificationProvider[] = [IdentificationProvider.GENEVE_ID, IdentificationProvider.VAUD_ID, IdentificationProvider.TRUST_ID, IdentificationProvider.HIN, IdentificationProvider.SWISS_ID];
  @Input() public filterProviders: boolean = false;

  private readonly excludedProviders: IdentificationProvider[] = [IdentificationProvider.HIN];

  constructor(
    private readonly identificationProviderService: IdentificationProviderService
  ) {
    this.user$ = this.identificationProviderService.getUser();
  }

  public async login(identificationProvider: IdentificationProvider) {
    this.beforeLogin.next();
    this.identificationProviderService.login(identificationProvider);
  }

  logout(): void {
    this.identificationProviderService.logOut();
  }

  ngOnInit(): void {
    if (this.filterProviders) {
      this.providersList = this.providersList.filter(
        provider => !this.excludedProviders.includes(provider)
      );
    }

  }
}
